import request from "@/service";

/**
 * 获取申报列表
 * @param {*} params 
 * @returns 
 */
 export function getClassReportPage(params) {
  return request({
    url: "/study/classReport/page",
    method: "get",
    params
  });
}

/**
 * 新增申报办班
 * @param {*} params 
 * @returns 
 */
 export function saveClassReport(params) {
  return request({
    url: "/study/classReport/save",
    method: "post",
    data: params
  });
}

/**
 * 编辑申报办班
 * @param {*} params 
 * @returns 
 */
 export function updateClassReport(params) {
  return request({
    url: "/study/classReport/update",
    method: "post",
    data: params
  });
}

/**
 * 申报办班详情
 * @param  
 * @returns 
 */
 export function getClassReportInfo(params) {
  return request({
    url: `/study/classReport/info`,
    method: "get",
    params
  });
}


/**
 * 删除申报办班
 * @param {*} params 
 * @returns 
 */
 export function deleteClassReport(params) {
  return request({
    url: "/study/classReport/delete",
    method: "post",
    data: params
  });
}

/**
 * 发布申报办班
 * @param {*} params 
 * @returns 
 */
 export function publishClassReport(params) {
  return request({
    url: "/study/classReport/publish",
    method: "post",
    data: params
  });
}
